export const SwiperSlider = function() {
    if (document.body.classList.contains('about_us') || document.body.classList.contains('homepage')) {
        const kundenLogos = new Swiper('.kunden-logos-swiper', {
            // Optional parameters
            direction: 'horizontal',

            slidesPerView: 4,
            loop: false,
            autoplay: {
                delay: 2500,
            },
            // And if we need scrollbar
            scrollbar: {
                el: '.swiper-scrollbar',
            },
            breakpoints: {

                768: {
                    slidesPerView: 4,
                },
                0: {
                    slidesPerView: 1,
                }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }

        });
    }else{
        if (document.querySelectorAll('.kunden-logos-swiper').length > 0) {
            document.getElementsByClassName('kunden-logos-swiper')[0].style.display = "none";
        }
    }

    if (document.body.classList.contains('about_us')) {
        document.querySelectorAll(".swiper-box").forEach(filterBox => {
            filterBox.addEventListener("click", function(e) {
                e.preventDefault();
                let filter = this.dataset.filterId;

                document.getElementsByClassName('kunden').forEach(slide => {
                    slide.style.display = "none";
                    if (slide.dataset.filterId === filter || filter == 0) {
                        slide.style.display = "";
                    }

                });

                document.querySelectorAll(".swiper-box").forEach(box => {
                    box.classList.remove("is-active");
                })
                this.classList.add("is-active");


                kundenSwiper.updateSlides();
                kundenSwiper.updateSlidesClasses();
                kundenSwiper.slideTo(0);

                return false;
            });
        });
    }
    const kundenSwiper = new Swiper ('.kunden-swiper', {
        /*grabCursor: true,*/
        direction: 'horizontal',
        slidesPerView: 1,
        runCallbacksOnInit: true,
        observer: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 5000,
        },
        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
        },
        updateOnImagesReady: true
    });


    const logos = new Swiper('.logos-swiper', {
        effect: 'cube',
        grabCursor: true,
        loop:true,
        cubeEffect: {
            slideShadows: false,
            shadow: false,
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false
        }
    });

    const newsList = new Swiper('.news-list-swiper', {
        direction: 'horizontal',
        slidesPerView: 1,
        loop: true,
        // And if we need scrollbar
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
        },
    });

}
